import { BusinessSettingName, Societe, SocieteTier } from '~/services/BusinessTraveller/BusinessTravellerService';

export const SETTING_NAMES: Array<BusinessSettingName> = ['societe', 'sabre_sync'];

export const SETTING_LABELS: Record<BusinessSettingName, string> = {
  societe: 'Societe',
  sabre_sync: 'Sabre sync',
};

// Tiers in display order. Adding a new tier means appending here + extending `Societe` + `DEFAULT_SOCIETE`.
export const SOCIETE_TIERS: Array<SocieteTier> = ['silver', 'gold', 'platinum'];

// LEBT currently only supports silver tier for the tier upgrade campaign
export const SUPPORTED_SOCIETE_TIERS: Array<SocieteTier> = ['silver'];

export const SOCIETE_TIER_LABELS: Record<SocieteTier, string> = {
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
};

// Initial values used when the user adds a new societe setting via "Add setting".
export const DEFAULT_SOCIETE: Societe = {
  silver: { threshold: 5, enabled: true },
  gold: { threshold: 100, enabled: false }, // Gold is not supported yet, hence disabled by default and hardcode a high threshold
  platinum: { threshold: 100, enabled: false }, // Platinum is not supported yet, hence disabled by default and hardcode a high threshold
};

// Form-state shape: mirrors `Societe` but holds `threshold` as a string so the input can be empty
// or contain "0" while the user is typing. Converted back to numbers on save.
export interface SocieteFormValue {
  threshold: string;
  enabled: boolean;
}

export type SocieteForm = Record<SocieteTier, SocieteFormValue>;

// Map a canonical `Societe` to its form-state shape (numbers → strings). Used on initialisation.
export function societeToForm(value: Societe): SocieteForm {
  return SOCIETE_TIERS.reduce(
    (acc, tier) => ({
      ...acc,
      [tier]: { threshold: String(value[tier].threshold), enabled: value[tier].enabled },
    }),
    {} as SocieteForm,
  );
}

// Map form state back to a canonical `Societe` (strings → numbers). Used on save.
export function formToSociete(form: SocieteForm): Societe {
  return SOCIETE_TIERS.reduce(
    (acc, tier) => ({
      ...acc,
      [tier]: { threshold: Number(form[tier].threshold), enabled: form[tier].enabled },
    }),
    {} as Societe,
  );
}
